import { Box, Button, Checkbox, Grid } from "@material-ui/core"
import { CircularLoading } from "views/components"
import { AccordionSaurus } from "views/components/accordions/accordion-saurus/accordion-saurus"
import { useStyles } from "./accordion-destinatarios-styles"
import { useThemeQueries } from "views/theme"
import { Paginacao } from "views/components/paginacao"
import { PropagandaRespostaData } from "../propaganda-resposta-data"
import { useCallback, useEffect, useRef, useState } from "react"
import { ApiListModel } from "model/api/gestao/api-list-model/api-list-model"
import { DestinatariosModel } from "model/api/gestao/destinatarios/destinatarios-model"
import { useGetRespostasDestinatarios } from "data/api/gestao/propaganda/get-respostas-destinatarios"
import { useParams } from "react-router-dom"
import { useCadastros, useSessaoAtual, useToastSaurus } from "services/app"
import { AccordionDestinatariosFiltros } from "./components/accordion-destinatarios-filtros/accordion-destinatarios-filtros"
import { useDeleteRemoverDestinatario } from "data/api/gestao/propaganda/delete-remover-destinatario"
import { useConfirm } from "material-ui-confirm"
import { EnumTipoPessoas } from "model/enums/enum-tipo-pessoas"
import { CancelarIcon, OkIcon } from "views/components/icons"
import { usePutDestinatario } from "data/api/gestao/propaganda/put-destinatario"
import { DestinatarioPostModel } from "model/api/gestao/destinatarios/destinatario-post-model"

export type TAccordionDestinatarioProps = {
    isRespondidos: boolean
}

export const AccordionDestinatarios = ({ isRespondidos, ...props }: TAccordionDestinatarioProps) => {
    const { theme } = useThemeQueries()
    const classes = useStyles()
    const { propagandaId } = useParams<{ propagandaId: string }>()
    const { showToast } = useToastSaurus()
    const confirm = useConfirm()
    const { tipoUsuario, usuario } = useSessaoAtual()
    const isRevenda = tipoUsuario() === EnumTipoPessoas.Revendedor
    const destinatarioSelecionadoEdicao = useRef<DestinatariosModel>()

    const { getRespostasDestinatarios, carregando: carregandoGetRespostas } = useGetRespostasDestinatarios()
    const { deleteRemoverDestinatario, carregando: carregandoDeleteRemover } = useDeleteRemoverDestinatario()
    const { putDestinatario, carregando: carregandoPutDestinatario } = usePutDestinatario()


    const { abrirCadastroPropagandaAddParametros } = useCadastros()

    const [selecionados, setSelecionados] = useState<Array<string>>([])
    const [isSelectMode, setIsSelectMode] = useState(false)

    const { cadastroPropagandaRespostaState } = useCadastros()

    const carregando = carregandoGetRespostas || carregandoDeleteRemover || carregandoPutDestinatario

    const [generico, setGenerico] = useState("")
    const [queryStatus, setQueryStatus] = useState<ApiListModel<DestinatariosModel>>({
        pageIndex: 1,
        totalPages: 0,
        totalResults: 0,
        pageSize: 0,
        list: Array<DestinatariosModel>(),
    });

    const fillResult = useCallback(
        async (
            page: number,
            totalPages: number,
            totalResults: number,
            list: Array<DestinatariosModel>
        ) => {
            setQueryStatus({
                pageIndex: page,
                list: list,
                totalResults: totalResults,
                totalPages: totalPages,
                pageSize: 0
            });
        },
        []
    );

    const search = useCallback(
        async (newPage: number) => {
            try {
                const queryBusca = `&respondido=${isRespondidos.toString()}${isRevenda ? `&revendaId=${usuario?.Id}` : ''}&pageSize=20${generico ? `&generico=${generico}` : ''}`

                const res = await getRespostasDestinatarios(newPage, propagandaId, queryBusca);

                if (res.erro) throw res.erro;

                if (!res.resultado) return

                fillResult(
                    res.resultado?.data.pageIndex,
                    res.resultado?.data.totalPages,
                    res.resultado?.data.totalResults,
                    res.resultado?.data.list,
                );

                return res;
            } catch (e: any) {
                showToast("error", e.message);
            }
        },
        [isRespondidos, isRevenda, usuario?.Id, generico, getRespostasDestinatarios, propagandaId, fillResult, showToast]
    );

    useEffect(() => {
        if (!cadastroPropagandaRespostaState) return
        search(queryStatus.pageIndex)
    }, [search, cadastroPropagandaRespostaState, queryStatus.pageIndex])

    const pageChanged = (newPage: number) => {
        if (newPage <= queryStatus.totalPages || newPage > 0) {
            search(newPage);
        }
    }

    const handleRemoveDestinatario = async (id: string) => {
        try {
            const res = await deleteRemoverDestinatario(propagandaId, id)
            if (res.erro) throw res.erro
            showToast('success', 'Destinatário removido com sucesso');
            search(queryStatus.pageIndex);
        } catch (err: any) {
            showToast('error', err.message || 'Erro ao remover destinatário');
        }
    }

    const onClickRemoveDestinatario = (id: string) => {
        confirm({
            title: 'Remover Destinatário',
            description: 'Tem certeza que deseja remover este destinatário?',
            confirmationText: 'Remover',
            cancellationText: 'Cancelar',
            confirmationButtonProps: {
                variant: 'contained'
            }
        }).then(async () => {
            await handleRemoveDestinatario(id);
        })
    }

    const handleRemoverSelecionados = async () => {
        try {
            for (const id of selecionados) {
                const res = await deleteRemoverDestinatario(propagandaId, id);
                if (res.erro) throw res.erro;
            }

            showToast('success', 'Destinatários removidos com sucesso');
            setSelecionados([]);
            setIsSelectMode(false);
            search(queryStatus.pageIndex);
        } catch (err: any) {
            showToast('error', err.message || 'Erro ao remover destinatários');
        }
    }

    const cancelarSelecao = () => {
        setIsSelectMode(false)
        setSelecionados([])
    }

    const idsDaPagina = queryStatus.list.map(item => item.id);
    const todosSelecionados = idsDaPagina.every(id => selecionados.includes(id));

    const selecionarTodos = () => {

        if (todosSelecionados) {
            setSelecionados(prev => prev.filter(id => !idsDaPagina.includes(id)));
        } else {
            setSelecionados(prev => {
                const novosIds = idsDaPagina.filter(id => !prev.includes(id));
                return [...prev, ...novosIds];
            });
        }
    }

    const selecionarDestinatario = (id: string) => {
        if (selecionados.includes(id)) {
            setSelecionados(prev => prev.filter(item => item !== id));
        } else {
            setSelecionados(prev => [...prev, id]);
        }
    }

    const alterarParametroDestinatario = async (parametro: string) => {
        try {
            const destinatario = destinatarioSelecionadoEdicao.current
            if (!destinatario) return
            destinatario.parametros = parametro
            const destinatarioEdit: DestinatarioPostModel = {
                parametros: parametro,
                id: destinatario.id,
                clienteId: destinatario.clienteId,
                referencia: destinatario.referencia,
                nivel: destinatario.nivel,
                ativo: destinatario.ativo,
                propagandaId: propagandaId,
            }
            const res = await putDestinatario(destinatarioEdit);
            if (res.erro) throw res.erro;

            showToast('success', 'Destinatário alterado com sucesso');
            search(queryStatus.pageIndex);
        } catch (err: any) {
            showToast('error', err.message || 'Erro ao alterar destinatário');
        }
    }

    const handleClickAlterarParametroDest = async (destinatario: DestinatariosModel) => {
        try {
            destinatarioSelecionadoEdicao.current = destinatario
            abrirCadastroPropagandaAddParametros(alterarParametroDestinatario, destinatario?.parametros || undefined)
        } catch (err: any) {
            showToast('error', err.message || 'Erro ao alterar destinatário');
        }
    }

    return (
        <AccordionSaurus
            labelPrimary={isRespondidos ? "Respondidas" : "Pendentes"}
            tipoExpand="bold"
            noPaperRoot={false}
            heightDivider={2}
            colorDivider={theme.palette.primary.main}
            colorExpand={theme.palette.primary.main}
            className={classes.accordionResposta}
            noPaddingContent
        >
            {carregando && <CircularLoading tipo="FULLSIZED" />}

            <div className={classes.defaultContainer}>
                <Grid container>
                    <AccordionDestinatariosFiltros setGenerico={setGenerico} />
                    <Grid item xs={12} className={classes.containerPaginacao}>
                        <Paginacao
                            currentPage={queryStatus.pageIndex}
                            totalPages={queryStatus.totalPages}
                            totalRegisters={queryStatus.totalResults}
                            pageChanged={pageChanged}
                        />
                    </Grid>
                    {!isRespondidos && queryStatus.list.length > 0 && (
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="space-between" mb={2} gridGap={8}>
                                <Box>
                                    <Button
                                        variant="outlined"
                                        size="large"
                                        color="inherit"
                                        onClick={() => isSelectMode ? cancelarSelecao() : setIsSelectMode(true)}
                                    >
                                        {isSelectMode ? <CancelarIcon tipo="BUTTON" /> : <OkIcon tipo="BUTTON" />}
                                        {isSelectMode ? 'Cancelar' : 'Selecionar respostas'}
                                    </Button>
                                </Box>
                                {isSelectMode && (
                                    <Box>
                                        <Button
                                            variant="outlined"
                                            color="inherit"
                                            onClick={selecionarTodos}
                                        >
                                            <Checkbox
                                            classes={{
                                                root: classes.checkbox,
                                            }}
                                                checked={todosSelecionados}
                                            />
                                            Selecionar todos
                                        </Button>
                                    </Box>
                                )}
                            </Box>
                        </Grid>
                    )}
                    <Grid item xs={12} className={classes.listContainer}>
                        <PropagandaRespostaData
                            list={queryStatus.list}
                            carregando={carregando}
                            isSelectMode={isSelectMode}
                            selecionados={selecionados}
                            isPendente={!isRespondidos}
                            onCardChecked={handleClickAlterarParametroDest}
                            onCardSelected={selecionarDestinatario}
                            onCardRemove={onClickRemoveDestinatario}
                        />
                    </Grid>
                    {isSelectMode && (
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="flex-end" mt={2}>
                                <Button
                                    variant="contained"
                                    size="large"
                                    className={classes.btnRemover}
                                    color="primary"
                                    onClick={() => {
                                        confirm({
                                            title: 'Remover Destinatários',
                                            description: `Tem certeza que deseja remover ${selecionados.length} destinatários selecionados?`,
                                            confirmationText: 'Remover',
                                            cancellationText: 'Cancelar',
                                            confirmationButtonProps: {
                                                variant: 'contained'
                                            }
                                        }).then(async () => {
                                            await handleRemoverSelecionados();
                                        })
                                    }}
                                >
                                    <CancelarIcon tipo="BUTTON_PRIMARY" />
                                    Remover {selecionados.length} respostas
                                </Button>
                            </Box>
                        </Grid>
                    )}

                </Grid>
            </div>
        </AccordionSaurus>
    )
}